import React, { useState } from "react";
import { Select } from "antd";
import { reclamations, wtrHarvesters } from "../../../../data";
import NegarimsTable from "../../../land-reclamation/negarims/NegarimsTable";
import CropBandTable from "../../../land-reclamation/crop-band/CropBandTable";
import ReclaimedSchemeTable from "../../../land-reclamation/schemes/ReclaimedSchemeTable";
import TreeCatchmentTable from "../../../land-reclamation/tree-catchment/TreeCatchmentTable";
import GrassBandTable from "../../../land-reclamation/grass-bands/GrassBandTable";
import { useSelector } from "react-redux";

function Reclamation() {
  const [selectId, setSelectId] = useState("Negarims");
  const { activeObjPathCard } = useSelector((state) => ({
    activeObjPathCard: state.obj.activeObj["pathwayCard"],
  }));

  return (
    <>
      <div className="flex justify-between">
        <div></div>
        <div className="flex items-center justify-end w-[20%]">
          <Select
            className=""
            allowClear
            style={{
              width: "100%",
            }}
            options={
              reclamations?.length > 0 &&
              reclamations?.map((item) => ({
                value: item?.value,
                label: item?.label,
              }))
            }
            value={selectId}
            onChange={(value) => setSelectId(value)}
            placeholder="Select"
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label?.toLocaleLowerCase() ?? "").includes(
                input?.toLocaleLowerCase()
              )
            }
          />
        </div>
      </div>
      {selectId === "Negarims" ? (
        <NegarimsTable pathwayId={activeObjPathCard?.irrigationPathwayId} />
      ) : selectId === "Crop_Bands" ? (
        <CropBandTable pathwayId={activeObjPathCard?.irrigationPathwayId} />
      ) : selectId === "Grass_Bands" ? (
        <GrassBandTable pathwayId={activeObjPathCard?.irrigationPathwayId} />
      ) : selectId === "Schemes" ? (
        <ReclaimedSchemeTable
          pathwayId={activeObjPathCard?.irrigationPathwayId}
        />
      ) : selectId === "Trees_Catchment" ? (
        <TreeCatchmentTable
          pathwayId={activeObjPathCard?.irrigationPathwayId}
        />
      ) : null}
    </>
  );
}

export default Reclamation;
